import { Card, CardContent, LinearProgress, Typography } from '@occc-app/design-system';

type SegmentUploadFileCardProps = {
  loading: boolean;
  children: React.ReactNode;
};

export const SegmentUploadFileCard = ({ loading, children }: SegmentUploadFileCardProps) => {
  return (
    <Card>
      {loading && <LinearProgress />}
      <CardContent>
        <Typography variant='body1' mb={2}>
          Or, upload a CSV with a Membership ID column to add members, remove members, or completely
          replace the members in a segment.
        </Typography>

        {children}
      </CardContent>
    </Card>
  );
};
